import axios from 'axios'
import { Dispatch } from '@reduxjs/toolkit'

export const fetchFeatureFlags = () => {
  return (dispatch: Dispatch) =>
    dispatch({
      type: 'FEATURE_FLAGS_FETCH',
      payload: axios('/features'),
    })
}
